/**
 * The pages that work only with the single-use `?token=` code in their address —
 * the routes in `router.tsx` that read a token: reset, invite, the candidate's test,
 * interview booking and offer.
 */
const TOKEN_LINK_PATHS: ReadonlySet<string> = new Set([
  '/reset-password',
  '/accept-invite',
  '/test',
  '/interview',
  '/offer',
]);

const TOKEN_PARAM = 'token';

/** Lets a relative address parse too; only its path and query are read. */
const RELATIVE_BASE = 'http://relative.invalid';

/**
 * Whether a link is one of those pages with its code taken out.
 *
 * The email delivery log keeps such links without the code on purpose (the API's
 * `withoutSecrets`): every HR Lead can read the log, and the code signs in as the
 * recipient. The address is still worth showing; opening it is not (D17).
 */
export function isLinkMissingItsCode(url: string): boolean {
  let parsed: URL;
  try {
    parsed = new URL(url, RELATIVE_BASE);
  } catch {
    // Not an address at all, so not one of ours either; it is shown as written.
    return false;
  }
  return TOKEN_LINK_PATHS.has(parsed.pathname) && !parsed.searchParams.has(TOKEN_PARAM);
}
